// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"a2656547","154":"c2f91b59","316":"d9c8446d","407":"56ae2672","587":"766a03fa","726":"be1eb9c9","901":"94d645dc"}[chunkId] + ".chunk.js";
};